import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mb-4",
  style: {"background-color":"var(--color-light-light-gray)","padding":"20px"}
}
const _hoisted_2 = { class: "h5 fw-bold mb-3" }
const _hoisted_3 = {
  class: "chart-container",
  style: {"position":"relative","height":"350px","width":"100%","padding-right":"25px"}
}
const _hoisted_4 = {
  ref: "cashFlowChart",
  class: "chart"
}
const _hoisted_5 = { class: "mt-0" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("project.previewAndReport.cashFlow.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("canvas", _hoisted_4, null, 512)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", {
        class: "mb-0",
        style: {"font-size":"12px"},
        innerHTML: _ctx.$t('project.previewAndReport.cashFlow.description')
      }, null, 8, _hoisted_6)
    ])
  ]))
}